import { normalizeRequestNumericFields } from './normalizeRequestNumericFields';
import { toProjectScopeArrayFromForm } from '../validation/opportunityProjectFieldsSchema';

/**
 * Aligns opportunity fields in queued offline payloads with API validation.
 * The client coerces legacy labels (e.g. "Power" → "Facility Power") on submit;
 * raw offline cache rows may still hold older tokens, which the server rejects.
 */
export function normalizeSyncedRequestPayload<
  T extends Record<string, unknown>,
>(data: T): T {
  if (data == null || typeof data !== 'object') {
    return data;
  }
  const out = normalizeRequestNumericFields({ ...data });
  if ('oppProjectScope' in out && out.oppProjectScope !== undefined) {
    out.oppProjectScope = toProjectScopeArrayFromForm(out.oppProjectScope);
  }
  return out as T;
}
